// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");
let SettingsPageHeader = require("./SettingsPageHeader.bs.js");
let UserViewPreferences = require("../common/UserViewPreferences.bs.js");
let ViewPreferencesForm = require("./ViewPreferencesForm.bs.js");

function ViewPreferences(props) {
  let preferences = UserViewPreferences.use();
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(SettingsPageHeader.make, {
        title: "Preferences"
      }),
      JsxRuntime.jsx(ViewPreferencesForm.make, {
        preferences: preferences.fragmentRefs
      })
    ],
    className: "space-y-8 rounded bg-white p-6 shadow-sm"
  });
}

let make = ViewPreferences;

exports.make = make;
/* react/jsx-runtime Not a pure module */
